/* esm.sh - rxjs@7.8.1/dist/esm/internal/observable/from */
import{scheduled as m}from"../scheduled/scheduled.mjs";import{innerFrom as f}from"./innerFrom.mjs";function e(r,o){return o?m(r,o):f(r)}export{e as from};
//# sourceMappingURL=from.mjs.map